import { ToastState, ToastAction, ToastActionType } from "./types";

/**
 * Simple reducer for toast state management
 * No default state needed since DLS component handles its own state
 */
export const toastReducer = (state: ToastState | null, action: ToastAction): ToastState | null => {
    switch (action.type) {
        case ToastActionType.SHOW_TOAST:
            return {
                props: action.payload.props,
                style: action.payload.style,
                isVisible: true,
            };

        case ToastActionType.HIDE_TOAST:
            return null;

        default:
            return state;
    }
};
